export const SIGN_UP_OPEN_MODAL = 'AUTH_SIGN_UP_OPEN_MODAL';
export const SIGN_UP_CLOSE_MODAL = 'AUTH_SIGN_UP_CLOSE_MODAL';
export const REQUEST_SENT_OPEN_MODAL = 'AUTH_REQUEST_SENT_OPEN_MODAL';
export const REQUEST_SENT_CLOSE_MODAL = 'AUTH_REQUEST_SENT_CLOSE_MODAL';
export const LOGIN_OPEN_MODAL = 'AUTH_LOGIN_OPEN_MODAL';
export const LOGIN_CLOSE_MODAL = 'AUTH_LOGIN_CLOSE_MODAL';
export const FORGOT_PASSWORD_OPEN_MODAL = 'AUTH_FORGOT_PASSWORD_OPEN_MODAL';
export const FORGOT_PASSWORD_CLOSE_MODAL = 'AUTH_FORGOT_PASSWORD_CLOSE_MODAL';
export const PROFILE_EDITOR_OPEN_MODAL = 'PROFILE_EDITOR_OPEN_MODAL';
export const PROFILE_EDITOR_CLOSE_MODAL = 'PROFILE_EDITOR_CLOSE_MODAL';
export const PROFILE_SELECTOR_OPEN_MODAL = 'PROFILE_SELECTOR_OPEN_MODAL';
export const PROFILE_SELECTOR_CLOSE_MODAL = 'PROFILE_SELECTOR_CLOSE_MODAL';
export const PROFILE_ENTER_MANAGE_MODE = 'PROFILE_ENTER_MANAGE_MODE';
export const PROFILE_LEAVE_MANAGE_MODE = 'PROFILE_LEAVE_MANAGE_MODE';
export const LOCK_DIARY = 'LOCK_DIARY';

export function openSignUpModal() {
  return {
    type: SIGN_UP_OPEN_MODAL
  };
}

export function closeSignUpModal() {
  return {
    type: SIGN_UP_CLOSE_MODAL
  };
}

export function openRequestSentModal() {
  return {
    type: REQUEST_SENT_OPEN_MODAL
  };
}

export function closeRequestSentModal() {
  return {
    type: REQUEST_SENT_CLOSE_MODAL
  };
}

export function openLoginModal() {
  return {
    type: LOGIN_OPEN_MODAL
  };
}

export function closeLoginModal() {
  return {
    type: LOGIN_CLOSE_MODAL
  };
}

export function openForgotPasswordModal() {
  return {
    type: FORGOT_PASSWORD_OPEN_MODAL
  };
}

export function closeForgotPasswordModal() {
  return {
    type: FORGOT_PASSWORD_CLOSE_MODAL
  };
}

export function openProfileEditorModal(profileId) {
  return {
    type: PROFILE_EDITOR_OPEN_MODAL,
    profileId
  };
}

export function closeProfileEditorModal() {
  return {
    type: PROFILE_EDITOR_CLOSE_MODAL
  };
}

export function openProfileSelectorModal() {
  return {
    type: PROFILE_SELECTOR_OPEN_MODAL
  };
}

export function closeProfileSelectorModal() {
  return {
    type: PROFILE_SELECTOR_CLOSE_MODAL
  };
}

export function enterProfileManageMode() {
  return {
    type: PROFILE_ENTER_MANAGE_MODE
  };
}

export function leaveProfileManageMode() {
  return {
    type: PROFILE_LEAVE_MANAGE_MODE
  };
}

export function lockDiary() {
  return {
    type: LOCK_DIARY
  };
}



// WEBPACK FOOTER //
// ./src/actions/auth.js